/**
 * @generated SignedSource<<be0f13acbf6da29e6e4d8dfbe2a84fb0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type LogEntrySeverity = "ERROR" | "INFO" | "WARNING";
import { FragmentRefs } from "relay-runtime";
export type EntityHistoryEntryIcon_entry$data = {
  readonly severity: LogEntrySeverity;
  readonly " $fragmentType": "EntityHistoryEntryIcon_entry";
};
export type EntityHistoryEntryIcon_entry$key = {
  readonly " $data"?: EntityHistoryEntryIcon_entry$data;
  readonly " $fragmentSpreads": FragmentRefs<"EntityHistoryEntryIcon_entry">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntityHistoryEntryIcon_entry",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "severity",
      "storageKey": null
    }
  ],
  "type": "LogEntry",
  "abstractKey": null
};

(node as any).hash = "663b373ca294943db12902a40096d2e4";

export default node;
